import type { AdditionalSelectors } from '../types';
import { MiddlewareManager } from './middleware';
import { Selectors } from './selectors';

export const SLICE_NAME = 'creditApp';
export let creditAppSelectors: Selectors;
export let middlewareManager: MiddlewareManager;

export const init = (additionalSelectors: AdditionalSelectors): { selectors: Selectors; middlewareManager: MiddlewareManager } => {
    creditAppSelectors = new Selectors(SLICE_NAME, additionalSelectors);
    middlewareManager = new MiddlewareManager(creditAppSelectors);

    return {
        selectors: creditAppSelectors,
        middlewareManager
    };
};
